import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function basketReducer(state = initialState.basket, action) {
  switch (action.type) {
    case types.UPDATE_BASKET_ITEM_IN_STORE_SUCCESS:
    case types.GET_BASKET_SUCCESS:
    case types.UPDATE_FULFILLMENT_SUCCESS:
    case types.SET_BASKET_CONSUMER_SUCCESS:
    case types.SET_BASKET_FULFILLAT_SUCCESS:
    case types.SET_PAYMENT_METHOD_SUCCESS:
    case types.REMOVE_BASKET_ITEM_SUCCESS:
    case types.UPDATE_BASKET_ITEM_SUCCESS:
    case types.ADD_VOUCHER_BASKET_SUCCESS:
      return action.basket;
    case types.DELETE_BASKET_SUCCESS:
      return {
        uuid: null,
        items: [],
        deletedBasket: true
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/basket.reducer.js